import { Disposable } from "../Disposable";
import { SignalBase } from "./SignalBase";

//
// Flambe - Rapid game development
// https://github.com/aduros/flambe/blob/master/LICENSE.txt

/**
 * Represents a connected signal listener.
 */
export class SignalConnection implements Disposable {
  constructor(signal: SignalBase | null, listener: any) {
    this._signal = signal;
    this._listener = listener;
  }

  /**
   * Tells the connection to dispose itself after being used once.
   * @returns This instance, for chaining.
   */
  public once() {
    this.stayInList = false;
    return this;
  }

  /**
   * Disconnects the listener from the signal.
   */
  public dispose(): void {
    if (this._signal != null) {
      this._signal.disconnect(this);
      this._signal = null;
    }
  }

  /**
   * True if the listener will remain connected after being used.
   */
  get stayInList() {
    return this._stayInList;
  }

  set stayInList(val: boolean) {
    this._stayInList = val;
  }

  _next: SignalConnection | undefined;
  _listener: any;
  _signal: SignalBase | undefined | null;
  _stayInList: boolean = true;
}
